import type { Locale } from './locales/_index';

const SUPPORTED: readonly Locale[] = ['en', 'zh', 'zh-tw', 'ja', 'ko', 'vi'] as const;

function normalize(tag: string): string {
  const lower = tag.toLowerCase();
  // Traditional Chinese variants
  if (lower === 'zh-tw' || lower === 'zh-hk' || lower === 'zh-mo' ||
      lower.startsWith('zh-hant')) return 'zh-tw';
  // Simplified Chinese (default for any other zh-*)
  if (lower.startsWith('zh')) return 'zh';
  // Otherwise BCP-47 first segment
  return lower.split('-')[0];
}

export function detectInitialLocale(): Locale {
  const tg = (window as unknown as {
    Telegram?: { WebApp?: { initDataUnsafe?: { user?: { language_code?: string } } } };
  }).Telegram?.WebApp?.initDataUnsafe?.user?.language_code;
  const browser = typeof navigator !== 'undefined' ? navigator.language : undefined;
  for (const candidate of [tg, browser]) {
    if (!candidate) continue;
    const norm = normalize(String(candidate));
    if ((SUPPORTED as readonly string[]).includes(norm)) return norm as Locale;
  }
  return 'en';
}
